// extracted by mini-css-extract-plugin
export default {"root":"_3UVCj","top":"gUqFA","bottom":"_1KIYp","middle":"_22Rof","indicators":"uFkaF","right":"_3FgET","engagement":"_2Rrw7"};